import React, { Component, Fragment } from 'react';
import { Redirect, withRouter } from 'react-router-dom';
import { Query } from 'react-apollo';
import Header from './Header';
import gql from 'graphql-tag';
import Loading from '../shared/Loading';
import SideBarContent from '../SideBar/SideBarContent';
import { StripeProvider } from 'react-stripe-elements';

import ScrollLock from 'react-scrolllock';

import PaymentsContainer from './PaymentsContainer';

import SinglePayment from './SinglePayment';
import PayBalance from './PayBalance';

import './payments.css';

class Payments extends Component {
  constructor(props) {
    super(props);
    this.state = {
      paymentSelected: null,
      statementOpen: false,
      selectedIndex: [0, 0],
      payingBalance: false
    };
  }

  onClick = () => {
    if (this.state.statementOpen) {
      this.setState({ statementOpen: false });
    } else {
      this.props.history.goBack();
    }
  };

  selectPayment = payment => {
    this.setState({ paymentSelected: payment, statementOpen: true });
  };

  togglePayingBalance = () => {
    this.setState({ payingBalance: !this.state.payingBalance });
  };

  render() {
    const { statementOpen, paymentSelected, payingBalance } = this.state;
    const { status, loggedIn, history, operatingCity } = this.props;
    const api_key =
      operatingCity === 'toronto'
        ? process.env.REACT_APP_STRIPE_PUBLISHABLE_KEY
        : process.env.REACT_APP_STRIPE_PUBLISHABLE_KEY_US;
    return window.innerWidth < 768 ? (
      <Redirect to="/downloadapp" />
    ) : (
      <Query
        query={gql`
          query PaymentIndex {
            paymentIndex {
              period
              payout
              balance
              cumulativeBalance
              outstandingBalance
              realTimeBalance
            }
            highestPaycheck {
              payout
            }
            latestStatement {
              period
              earnings
              payout
              balance
              cumulativeBalance
              outstandingBalance
              realTimeBalance
            }
            currentUser {
              id
              email
              firstName
              lastName
              fullName
              operatingCity
              stripeCustomerId
              financingRequested
            }
          }
        `}
        fetch-policy="network-only">
        {({ loading, error, data, refetch }) => {
          if (error) {
            console.log(error);
            return <Redirect to="/404" />;
          }
          if (loading) return <Loading size="3x" />;
          const { latestStatement, highestPaycheck } = data;
          const isTablet = window.innerWidth >= 768;
          return (
            <Fragment>
              {payingBalance && !isTablet ? null : (
                <Header
                  title="My Earnings"
                  back
                  onClick={this.onClick}
                  statementOpen={statementOpen}
                />
              )}
              <div className="payments__body container">
                <ScrollLock>
                  <div
                    className="payments__container"
                    style={
                      payingBalance && !isTablet ? { marginTop: '0' } : {}
                    }>
                    {payingBalance ? null : (
                      <div
                        className={`payments__statements--border ${
                          !latestStatement
                            ? 'payments__statements--border--left'
                            : ''
                        }`}
                      />
                    )}
                    <div className="profile__sidebar">
                      <SideBarContent
                        status={status}
                        signedIn={loggedIn}
                      />
                    </div>
                    {payingBalance ? (
                      <StripeProvider apiKey={api_key}>
                        <PayBalance
                          history={history}
                          latestStatement={data.latestStatement}
                          currentUser={data.currentUser}
                          amount={Math.abs(
                            data.latestStatement.realTimeBalance
                          )}
                          togglePayingBalance={this.togglePayingBalance}
                        />
                      </StripeProvider>
                    ) : null}
                    {!payingBalance &&
                    latestStatement &&
                    (!statementOpen || isTablet) ? (
                      <PaymentsContainer
                        payments={data.paymentIndex}
                        latestStatement={data.latestStatement}
                        selectPayment={this.selectPayment}
                        currentUser={data.currentUser}
                        highestPaycheck={highestPaycheck}
                        togglePayingBalance={this.togglePayingBalance}
                      />
                    ) : null}
                    {!payingBalance &&
                    latestStatement &&
                    (statementOpen || isTablet) ? (
                      <SinglePayment
                        currentUser={data.currentUser}
                        periodStart={(
                          paymentSelected || data.latestStatement
                        ).period.replace(/\..*/, '')}
                        latestStatementStart={data.latestStatement.period.replace(
                          /\..*/,
                          ''
                        )}
                        highestPaycheck={highestPaycheck}
                      />
                    ) : null}
                    {!latestStatement ? (
                      <div className="payments__container--no-history">
                        {' '}
                        No payment history on record{' '}
                      </div>
                    ) : null}
                  </div>
                </ScrollLock>
              </div>
            </Fragment>
          );
        }}
      </Query>
    );
  }
}
export default withRouter(Payments);



// WEBPACK FOOTER //
// ./src/components/NewPayments/index.js